
import * as d3 from 'd3'
var RadarChart = {
  defaultConfig: {
    containerClass: 'radar-chart',
    w: 300,
    h: 300,
    componentId: '',
    componentColor: '#1cb5e0',
    factor: 0.95,
    factorLegend: 1,
    TickLength: 10,
    maxValue: 100,
    minValue: 0,
    maxAverage: 100,
    minAverage: 0,
    radians: 2 * Math.PI,
    color: d3.scaleOrdinal(d3.schemeCategory10),
    axisLine: true,
    axisText: true,
    circles: true,
    radius: 5,
    backgroundTooltipColor: "#555",
    backgroundTooltipOpacity: "0.7",
    tooltipColor: "white",
    axisJoin: function (d, i) {
      return d.className || i;
    },
    tooltipFormatValue: function (d) {
      return d;
    },
    tooltipFormatClass: function (d) {
      return d;
    },
    transitionDuration: 300
  },
  chart: function () {
    var cfg = Object.create(RadarChart.defaultConfig);
    let componentId = RadarChart.defaultConfig.componentId
    let componentColor = RadarChart.defaultConfig.componentColor
    function setTooltip(msg) {
      let node = d3.select('.tooltip')
      if (msg) {
        let coords = d3.mouse(node.node());
        node.classed("visible", true);
        node.select("text").classed('visible', true).style("fill", cfg.tooltipColor);
        let padding = 5;
        let box = node.select("text").text(msg).node().getBBox();

        node.select("rect")
          .classed('visible', true)
          .attr("x", -coords[0])
          .attr("y", -coords[1])
          .attr("width", box.width + (padding * 2))
          .attr("height", box.height + (padding * 2))
          .attr("rx", "5").attr("ry", "5")
          .style("fill", cfg.backgroundTooltipColor).style("opacity", cfg.backgroundTooltipOpacity);
        node.attr("transform", "translate(" + (coords[0] + 10) + "," + (coords[1] - 10) + ")")

        node.select("text")
          .classed('visible', true)
          .attr("x", coords[0] - (box.width + padding))
          .attr("y", coords[1] - (box.height - padding - 1))
        node.attr("transform", "translate(" + (-1 * (coords[0] + 10)) + ",-" + (-1 * (coords[1] - 10)) + ")")
      } else {
        node.classed("visible", false);
        node.select("rect").classed("visible", false);
      }
    }

    function radar(selection) {
      selection.each(function (data) {
        var container = d3.select(this);
        // allow simple notation
        data = data.map(function (datum) {
          if (datum instanceof Array) {
            datum = { axes: datum };
          }
          return datum;
        });

        var maxValue = Math.max(cfg.maxValue, d3.max(data, function (d) {
          return d3.max(d.axes, function (o) { return o.value; });
        }));
        maxValue -= cfg.minValue;

        var maxAverage = Math.max(cfg.maxAverage, d3.max(data, function (d) {
          return d3.max(d.axes, function (o) { return o.Average; });
        }));
        maxAverage -= cfg.minAverage;

        var allAxis = data[0].axes.map(function (i, j) { return { name: i.axis, rankLevel: i.rankLevel, xOffset: (i.xOffset) ? i.xOffset : 0, yOffset: (i.yOffset) ? i.yOffset : 0 }; });
        var total = allAxis.length;
        var radius = cfg.factor * Math.min(cfg.w / 2, cfg.h / 2);
        var radius2 = Math.min(cfg.w / 2, cfg.h / 2);
        container.classed(cfg.containerClass+componentId, 1)

        function getPosition(i, range, factor, func) {
          factor = typeof factor !== 'undefined' ? factor : 1;
          return range * (1 - factor * func(i * cfg.radians / total));
        }
        function getHorizontalPosition(i, range, factor) {
          return getPosition(i, range, factor, Math.sin);
        }
        function getVerticalPosition(i, range, factor) {
          return getPosition(i, range, factor, Math.cos);
        }

        var temp = '';
        var polygonBG = d3.selectAll('.radar-chart'+componentId).append('polygon')
        polygonBG
          // .attr('class', 'bg-color')
          .classed('bg-color', true)
          .attr('points', function () {
            allAxis.map(function (d, i) {
              temp += (cfg.w / 2 - radius2) + getHorizontalPosition(i, radius2, cfg.factor) + ',' + (cfg.h / 2 - radius2) + getVerticalPosition(i, radius2, cfg.factor) + ' '
            })
            return temp
          })

        if (cfg.axisLine || cfg.axisText) {
          var axis = container.selectAll('#axis-'+componentId).data(allAxis);
          var newAxis = axis.enter().append('g').classed('axis', true).attr('id', 'axis-'+componentId); //draw line

          axis.exit().remove();
          axis.attr('class', 'axis'); // draw line    

          newAxis.append('line')
            .attr('x1', cfg.w / 2)
            .attr('y1', cfg.h / 2)
            .attr('x2', function (d, i) { return (cfg.w / 2 - radius2) + getHorizontalPosition(i, radius2, cfg.factor); })
            .attr('y2', function (d, i) { return (cfg.h / 2 - radius2) + getVerticalPosition(i, radius2, cfg.factor); });
        }

        // Average
        data.forEach(function (d) {
          d.axes.forEach(function (axis, i) {
            axis.x1 = (cfg.w / 2 - radius2) + getHorizontalPosition(i, radius2, (parseFloat(Math.max(axis.Average - cfg.minAverage, 0)) / maxAverage) * cfg.factor);
            axis.y1 = (cfg.h / 2 - radius2) + getVerticalPosition(i, radius2, (parseFloat(Math.max(axis.Average - cfg.minAverage, 0)) / maxAverage) * cfg.factor);
          });
        });

        var polygonAvg = container.selectAll(".radar-chart"+componentId).data(data, cfg.axisJoin);

        polygonAvg.enter().append('polygon')
          .classed('d3-enter', true)
          .classed('area-average', true)
          .attr('points', function (d) {
            return d.axes.map(function (p) {
              return [p.x1, p.y1].join(',');
            }).join(' ');
          })
          .on('mouseover', function (d) {
            d3.event.stopPropagation();
            container.classed('focus', true);
            d3.select(this).classed('focused', true);
            setTooltip(false);
          })
          .on('mouseout', function () {
            d3.event.stopPropagation();
            container.classed('focus', false);
            d3.select(this).classed('focused', false);
            setTooltip(false);
          });

        polygonAvg.exit().remove();

        // Value
        data.forEach(function (d) {
          d.axes.forEach(function (axis, i) {
            axis.x = (cfg.w / 2 - radius2) + getHorizontalPosition(i, radius2, (parseFloat(Math.max(axis.value - cfg.minValue, 0)) / maxValue) * cfg.factor);
            axis.y = (cfg.h / 2 - radius2) + getVerticalPosition(i, radius2, (parseFloat(Math.max(axis.value - cfg.minValue, 0)) / maxValue) * cfg.factor);
          });
        });

        let polygon = container.selectAll(".radar-chart"+componentId).data(data, cfg.axisJoin);
        // space blue
        polygon.enter().append('polygon')
          .classed('area', true)
          .style('fill', componentColor)
          .attr('points', function (d) {
            return d.axes.map(function (p) {
              return [p.x, p.y].join(',');
            }).join(' ');
          })
          .on('mouseover', function (d) {
            d3.event.stopPropagation();
            container.classed('focus', true);
            d3.select(this).classed('focused', true);
            setTooltip(false);
          })
          .on('mouseout', function () {
            d3.event.stopPropagation();
            container.classed('focus', false);
            d3.select(this).classed('focused', false);
            setTooltip(false);
          });

        polygon.exit().remove();

        let circleGroup = container.selectAll(".radar-chart").data(data[0].axes, cfg.axisJoin);

        circleGroup.exit()
          .transition().duration(cfg.transitionDuration).remove();

        circleGroup.enter().append('circle')
          .classed('circle', true)
          .style('fill', '#fff')
          .style('stroke', function (d) { return cfg.color(d[1]) })
          .on('mouseover', function (d) {
            d3.event.stopPropagation();
            setTooltip(cfg.tooltipFormatValue(d.value));
          })
          .attr('r', cfg.radius)
          .attr('cx', function (d) {
            return d.x;
          })
          .attr('cy', function (d) {
            return d.y;
          })
          .on('mouseout', function (dd) {
            d3.event.stopPropagation();
            setTooltip(false);
            container.classed('focus', 0);
          });

        circleGroup.exit()
          .transition().duration(cfg.transitionDuration).remove();

        var tooltip = container.selectAll('g.tooltip').data([data[0]]);
        var box = tooltip.enter()
          .append('g')
          .classed('tooltip', true)

        box.append('rect').classed("tooltip", true);
        box.append('text').classed("tooltip-text", true);

      });
    }

    radar.config = function (value) {
      if (!arguments.length) {
        return cfg;
      }
      if (arguments.length > 1) {
        cfg[arguments[0]] = arguments[1];
      }
      else {
        d3.entries(value || {}).forEach(function (option) {
          cfg[option.key] = option.value;
        });
      }
      return radar;
    };

    return radar;
  },
  draw: function (id, data, options) {
    let chart = RadarChart.chart().config(options);
    let cfg = chart.config();

    // d3.select(id)
    //   .append("svg")
    //   .attr("width", cfg.w)
    //   .attr("height", cfg.h)
    //   .datum(data)
    //   .call(chart);
  }
};

export default {
  RadarChart
}